import { LOCAL_STORAGE_USER_LOGIN_INFO } from "@app/constants/Common";
import { requestGetJobList } from "@app/services/JobService";
import { requestGetUserList } from "@app/services/UserService";
import { stringToOption } from "@app/utils/CommonUtils";
import { DateUtils } from "@app/utils/DateUtils";
import {
    DVTJCUVPipelineSearchExceptOptions,
    DVTJCUVPipelineSearchOnlyGetOptions,
    DVTJCUVPipelineTableColumns, JobFindModeOptions,
    SearchPipelineFields
} from "@pages/dvtjcuv/common/Constant";
import { findOneOptionByValue } from "@pages/dvtjcuv/common/PipelineUtil";
import { InternalProcessOptions, MemberInternalProcessOptions } from "@pages/jobpipeline/common/Constant";
import { cloneDeep } from "lodash";
import React, { useEffect, useState } from 'react';
import Select from "react-select";

export const DVTJCUVPipelineInputMode = {
    Add: 1,
    Edit: 2,
    Search: 3
}

const TimeRangeSelection = {
    Week: { value: 1, label: 'Tuần' },
    Month: { value: 2, label: 'Tháng' }
}

export const DVTJCUVPipelineTableColumGroups = [
    { color: '#FFFFFF', autoAdd: true, title: '' },
    { color: '#CCECFF', title: 'Cdd' },
    { color: '#2F5496', title: 'Acquire Cdd' },
    { color: '#FF5050', title: 'FU this time' },
    { color: '#CC99FF', title: 'FU next time' },
    { color: '#F7CAAC', title: 'Cdd Rec & Emp' },
    { color: '#92D050', title: 'Connect Cdd-Emp' },
    { color: '#FF9900', title: 'MỜI GỬI JOB' },
    { color: '#FF0009', title: 'FU Cdd-Emp' },
    { color: '#ADB9CA', title: 'Note Discussion' },
    { color: '#FFE598', title: 'Thanh toán - Bảo hành' },
    { color: '#548135', title: 'Note' },
]

const TimeRangeOptions = Object.values(TimeRangeSelection)

const RefereeHighlightColumns = {
    'user_qualify_uv': { 'color_class': 'text-danger' },
    'todo_with_person': { 'color_class': 'text-danger' },
    'internal_process': { 'color_class': 'text-danger' },
    'cdd_status': { 'color_class': 'text-success' },
    'interactive_channel': { 'color_class': 'text-success' }
}

const OnlyAdminColumns = [
    'cdd_to_employer_process', 'payment_and_warranty'
]

const DVTJCUVPipelineInputFormNew = (props) => {
    const [dvtjcuvPipeline, setDVTJCUVPipeline] = useState({});
    const [inputMode, setInputMode] = useState(null)
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [userSearchOptions, setUserSearchOptions] = useState([]);
    const [disableFields, setDisableFields] = useState([]);
    const [fieldList, setFieldList] = useState([]);
    const [selectJobOptions, setSelectJobOptions] = useState([]);
    const [selectJob, setSelectJob] = useState({});

    const { pipeLineInfo, isShow, mode, onClose, cddId, onChangeInputItem } = props

    useEffect(() => {
        setInputMode(mode)
        if (mode === DVTJCUVPipelineInputMode.Search) {
            setFieldList(cloneDeep(SearchPipelineFields))
        } else {
            const fields = cloneDeep(DVTJCUVPipelineTableColumns)
            if (pipeLineInfo.read_only) {
                const displayFields = fields.map(item => {
                    item.editable = false
                    return item
                })
                setFieldList(displayFields)
            } else {
                setFieldList(fields)
            }

        }
    }, [mode, pipeLineInfo])

    const onSelectJob = (jobOption, column) => {
        setSelectJob(jobOption)
        // from joboption set job_id to dvtjcuvPipeline
        dvtjcuvPipeline.job_id = jobOption.value
        setDVTJCUVPipeline({ ...dvtjcuvPipeline })
        if (onChangeInputItem) {
            onChangeInputItem(jobOption.value, column)
        }
    }

    const fetchJobList = async (employerId) => {
        const res = await requestGetJobList({ unlimited: true, search_conditions: { employer_id: employerId } });
        const jobOptionList = res.content.jobs.map((item) => {
            return { value: item.id, label: item.job_name }
        });
        // add option blank to jobOptionList
        jobOptionList.splice(0, 0, { value: "", label: "", id: "" })
        setSelectJobOptions(jobOptionList);

        // from pipeline.job_id set selectJob
        if (pipeLineInfo.job_id) {
            const jobOption = jobOptionList.find(job => job.value.toString() === pipeLineInfo.job_id.toString())
            if (jobOption) {
                setSelectJob(jobOption)
            } else {
                setSelectJob({})
            }
        }
    }

    const fetchUsers = async () => {
        const res = await requestGetUserList({});
        const userList = res.content.users
        const userOptionList = userList.map(user => {
            return { value: user.id, label: user.email, id: user.id }
        })

        // userOptionList.splice(0, 0, {value: "", label : "Tất cả users", id: ""})
        setUserSearchOptions([...userOptionList])
    };

    useEffect(() => {
        let loginUser = {}
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            loginUser = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO))
            setUserLoginInfo(loginUser)

            if (mode === DVTJCUVPipelineInputMode.Search) {
                if (loginUser.is_superuser) {
                    fetchUsers()
                } else {
                    setUserSearchOptions(
                        [
                            { value: loginUser.id, label: "Chỉ NL của mình", id: loginUser.id },
                        ]
                    )
                }
            }
        }

    }, [])

    const setPipelineInfoForDisplay = async (inputPipeline) => {
        const pipeline = { ...inputPipeline }
        pipeline.current_find_job_mode = findOneOptionByValue(JobFindModeOptions, pipeline.current_find_job_mode)
        pipeline.dvtjcuv_find_job_mode = findOneOptionByValue(JobFindModeOptions, pipeline.dvtjcuv_find_job_mode)
        // console.log('pipeline me check status:' + pipeline.cdd_me_check_status)
        pipeline.gp_cdd_process = stringToOption(pipeline.gp_cdd_process, true)
        pipeline.us_qualify_cdd = stringToOption(pipeline.us_qualify_cdd, true)
        pipeline.to_do_w_cdd = stringToOption(pipeline.to_do_w_cdd, true)
        pipeline.gp_emp_process = stringToOption(pipeline.gp_emp_process, false)
        pipeline.invite_send_job_gp_emp_process = stringToOption(pipeline.invite_send_job_gp_emp_process, false)
        pipeline.invite_send_job_todo_w_rec = stringToOption(pipeline.invite_send_job_todo_w_rec, false)
        pipeline.matching_potential = stringToOption(pipeline.matching_potential, false)
        pipeline.cdd_emp_process = stringToOption(pipeline.cdd_emp_process, false)
        pipeline.cdd_emp_fu_needed = stringToOption(pipeline.cdd_emp_fu_needed, true)
        pipeline.payment_and_warranty = stringToOption(pipeline.payment_and_warranty, false)
        pipeline.gd_tt_bh_fu_needed = stringToOption(pipeline.gd_tt_bh_fu_needed, true)
        pipeline.cdd_receiver_me_check_status = stringToOption(pipeline.cdd_receiver_me_check_status, false)
        pipeline.interactive_channel = stringToOption(pipeline.interactive_channel, false)
        pipeline.candidate_receive_request = stringToOption(pipeline.candidate_receive_request, true)
        pipeline.cdd_receiver_category = stringToOption(pipeline.cdd_receiver_category, true)

        if (pipeline.employer_id) {
            await fetchJobList(pipeline.employer_id)
        }
        setDVTJCUVPipeline({ ...pipeline })
    }

    useEffect(() => {
        if (pipeLineInfo) {
            setPipelineInfoForDisplay(pipeLineInfo)
            if (pipeLineInfo.fromReferee) {
                setDisableFields([
                    'job_id',
                    'referer_id',
                    'candidate_id',
                    'comment_from_referer',
                    'function',
                    'cdd_receiver_function',
                ])
            } else {
                setDisableFields([
                    'function',
                    'cdd_receiver_function',
                ])
            }
        } else {
            setDVTJCUVPipeline({})
        }

        // if (mode === DVTJCUVPipelineInputMode.Add || mode === DVTJCUVPipelineInputMode.Edit) {
        //     disableFields.push('employer_id')
        //     disableFields.push('employer_name')
        // }

        if (cddId) {
            disableFields.push('cdd_id')
            dvtjcuvPipeline.cdd_id = cddId
            setDVTJCUVPipeline({ ...dvtjcuvPipeline })
        }
        setDisableFields([...disableFields])

    }, [pipeLineInfo, cddId]);

    const onChangeInput = (values, column) => {
        dvtjcuvPipeline[column.key] = values
        setDVTJCUVPipeline({ ...dvtjcuvPipeline })

        if (onChangeInputItem) {
            onChangeInputItem(values, column)
        }
    }

    const getItemValues = (column, values) => {
        return values || ""
    }

    const getOptions = (column) => {
        if (column.key === 'internal_process') {
            return userLoginInfo.is_superuser ? InternalProcessOptions : MemberInternalProcessOptions
        }

        return column.options
    }

    const highLightLabel = (column) => {
        if (dvtjcuvPipeline.fromReferee) {
            const refereeHighLight = RefereeHighlightColumns[column.key]
            if (refereeHighLight) {
                return refereeHighLight['color_class']
            }
        }
        return ""
    }

    const addWeekMonthFromCurrentDate = (column) => {
        if (!column.originValue) {
            column.originValue = dvtjcuvPipeline[column.key]
        }

        if (!column.timeRangeSelect) {
            column.timeRangeSelect = TimeRangeSelection.Week
        }

        // Trường hợp clear thông tin input số ngày/tháng => reset lại giá trị ban đầu.
        if (!column.timeRangeNumber) {
            dvtjcuvPipeline[column.key] = column.originValue
        } else {
            const currentDate = new Date();
            const newDate = column.timeRangeSelect.value === TimeRangeSelection.Month.value
                ? DateUtils.addMonths(currentDate, column.timeRangeNumber) : DateUtils.addWeeks(currentDate, column.timeRangeNumber)

            dvtjcuvPipeline[column.key] = newDate.toISOString().slice(0, 10)
        }

        setDVTJCUVPipeline({ ...dvtjcuvPipeline })

        if (onChangeInputItem) {
            onChangeInputItem(dvtjcuvPipeline[column.key], column)
        }
    }

    const onChangeRangeNumber = (event, column) => {
        column.timeRangeNumber = event.target.value
        setFieldList([...fieldList])
        addWeekMonthFromCurrentDate(column)
    }

    const onChangeRangeOption = (value, column) => {
        column.timeRangeSelect = value
        setFieldList([...fieldList])
        addWeekMonthFromCurrentDate(column)
    }

    const isDisableColumn = (column) => {
        return ((inputMode === DVTJCUVPipelineInputMode.Add
            || inputMode === DVTJCUVPipelineInputMode.Edit) && !column.editable
        ) || disableFields.includes(column.key)
    }

    const onChangeCreateDate = (event) => {
        dvtjcuvPipeline[event.target.name] = event.target.value;
        setDVTJCUVPipeline({ ...dvtjcuvPipeline });
        if (onChangeInputItem) {
            onChangeInputItem(event.target.value, { key: event.target.name });
        }
    };

    const onChangeOnlyGetOrExceptInputItem = (values, fieldKey) => {
        dvtjcuvPipeline[fieldKey] = values
        setDVTJCUVPipeline({ ...dvtjcuvPipeline });
        if (onChangeInputItem) {
            onChangeInputItem(values, { key: fieldKey });
        }
    };

    // fieldKey là field mà input giá trị điều kiện search, không phải key của checkbox.
    const onCheckOnlyGetOrExpectCondCheckbox = (event, fieldKey) => {
        const checkKey = event.target.name;
        const checkValue = dvtjcuvPipeline[checkKey];
        if (checkValue) {
            // Reset choose values on options
            onChangeOnlyGetOrExceptInputItem([], fieldKey);
        }
        dvtjcuvPipeline[checkKey] = !checkValue;
        if (onChangeInputItem) {
            onChangeInputItem(dvtjcuvPipeline[checkKey], { key: checkKey });
        }
        setDVTJCUVPipeline({ ...dvtjcuvPipeline });
    };

    return (
        <div className=''>
            {inputMode === DVTJCUVPipelineInputMode.Search &&
                <>
                    <div className='pipeline-info-card card card-default w-100'>
                        <div className='card-header'>
                            <h3 className='card-title'>Phạm vi search</h3>
                        </div>
                        <div className='card-body'>
                            <div className='col-sm-12'>
                                <div className="form-group">
                                    <label className={''}>Chỉ lấy</label>
                                    {/* <div className='input-group'>
                                        <label>Chỉ NL của mình</label>
                                        <input type="checkbox"
                                               className="ml-3" name={'only_user_input'}
                                               style={{width: 20, height: 20}}
                                               value={!!searchConditions.only_user_input}
                                               checked={searchConditions.only_user_input === true}
                                               onChange={event => setSearchOnlyInputByMyselfConditionItem(event)}/>
                                    </div> */}
                                    <input type="checkbox"
                                        className="ml-3"
                                        style={{ width: 20, height: 20 }}
                                        name={'check_only_get_conds'}
                                        value={!!dvtjcuvPipeline.check_only_get_conds}
                                        checked={dvtjcuvPipeline.check_only_get_conds === true}
                                        onChange={event => onCheckOnlyGetOrExpectCondCheckbox(event, 'only_get_conds')}
                                    />

                                    <Select options={DVTJCUVPipelineSearchOnlyGetOptions}
                                        placeholder={''}
                                        isMulti
                                        value={dvtjcuvPipeline.only_get_conds || []}
                                        isDisabled={!dvtjcuvPipeline.check_only_get_conds}
                                        name={'only_get_conds'}
                                        onChange={value => {
                                            onChangeOnlyGetOrExceptInputItem(value, 'only_get_conds');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className='col-sm-12'>
                                <div className="form-group">
                                    <label className={''}>Loại</label>
                                    <input type="checkbox"
                                        className="ml-3"
                                        style={{ width: 20, height: 20 }}
                                        name={'check_except_conds'}
                                        value={!!dvtjcuvPipeline.check_except_conds}
                                        checked={dvtjcuvPipeline.check_except_conds === true}
                                        onChange={event => onCheckOnlyGetOrExpectCondCheckbox(event, 'except_conds')}
                                    />
                                    <Select options={DVTJCUVPipelineSearchExceptOptions}
                                        placeholder={''}
                                        isMulti
                                        value={dvtjcuvPipeline.except_conds || []}
                                        isDisabled={!dvtjcuvPipeline.check_except_conds}
                                        name={'except_conds'}
                                        onChange={value => {
                                            onChangeOnlyGetOrExceptInputItem(value, 'except_conds');
                                        }}
                                    />
                                </div>
                            </div>
                            <div className={'col-sm-12'}>
                                <label>NL bởi users</label>
                                <Select options={userSearchOptions}
                                    isMulti
                                    placeholder={"Tất cả users"}
                                    value={dvtjcuvPipeline.created_user}
                                    onChange={values => {
                                        onChangeInput(values, { key: 'created_user' });
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='card card-default'>
                        <div className='card-header'>
                            <h3 className='card-title'>Note time</h3>
                        </div>
                        <div className='card-body row'>
                            <div className='input-group col-sm-6'>
                                <div style={{ width: '100%' }}>
                                    <div className="form-group">
                                        <label>Ngày bắt đầu</label>
                                        <input type="date"
                                            className="form-control" name={'created_start_date'}
                                            value={dvtjcuvPipeline.created_start_date}
                                            onChange={event => onChangeCreateDate(event)}
                                            maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                            <div className='input-group col-sm-6'>
                                <div style={{ width: '100%' }}>
                                    <div className="form-group">
                                        <label className={'w-100'}><b>Ngày kết thúc</b></label>
                                        <input type="date"
                                            className="form-control" name={'created_end_date'}
                                            value={dvtjcuvPipeline.created_end_date}
                                            onChange={event => onChangeCreateDate(event)}
                                            maxLength="10" placeholder="mm/dd/yyyy" autoComplete="off" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            }

            {DVTJCUVPipelineTableColumGroups.map((gr, gi) => {
                return <div className='pipeline-info-card card card-default w-100'
                    key={`update_job_pipeline_input_group_${gi}`}>
                    <div className='card-header' style={{ backgroundColor: gr.color }}>
                        <h3 className='card-title text-white'>{gr.title}</h3>
                    </div>
                    <div className='card-body'>
                        {fieldList.map(column => {
                            if (column.group !== (gi + 1) || (inputMode === DVTJCUVPipelineInputMode.Add && column.autoAdd)
                                || (inputMode === DVTJCUVPipelineInputMode.Search && !column.searchable)
                                || (inputMode !== DVTJCUVPipelineInputMode.Search && OnlyAdminColumns.includes(column.key) && !userLoginInfo.is_superuser)) {
                                return ""
                            }

                            // if field is job_id
                            if (inputMode === DVTJCUVPipelineInputMode.Add && column.key === 'job_id') {
                                return ""
                            }

                            if (inputMode === DVTJCUVPipelineInputMode.Edit && column.key === 'job_id') {
                                return <div className='col-sm-12' key={`update_job_pipeline_input_item_${column.key}`}>
                                    <label className={'w-100'}>{column.label}</label>
                                    <div className='form-group'>
                                        <Select options={selectJobOptions}
                                            placeholder={"Chọn job"}
                                            value={selectJob}
                                            isDisabled={isDisableColumn(column)}
                                            onChange={values => {
                                                onSelectJob(values, column);
                                            }}
                                        />
                                    </div>
                                </div>
                            }

                            if (column.inputType === 'option') {
                                return <div className='col-sm-12' key={`update_job_pipeline_input_item_${column.key}`}>
                                    <div className='form-group'>
                                        <div style={{ width: '100%' }}>
                                            <label className={`w-100 ${highLightLabel(column)}`}>{column.label}</label>
                                            <Select options={getOptions(column)}
                                                value={getItemValues(column, dvtjcuvPipeline[column.key])}
                                                isDisabled={isDisableColumn(column)}
                                                name={column.key}
                                                isMulti={!!column.isMulti}
                                                onChange={value => {
                                                    onChangeInput(value, column);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            }

                            if (column.inputType === 'textarea') {
                                return <div className='col-sm-12' key={`update_job_pipeline_input_item_${column.key}`}>
                                    <div className='form-group '>
                                        <label className={`w-100 ${highLightLabel(column)}`}>{column.label}</label>
                                        <textarea className='form-control'
                                            value={getItemValues(column, dvtjcuvPipeline[column.key])}
                                            name={column.key}
                                            disabled={isDisableColumn(column)}
                                            onChange={event => onChangeInput(event.target.value, column)} />
                                    </div>
                                </div>
                            }

                            const handleKeyDownNumber = (event) => {
                                if (event.key === "-" || event.keyCode === 189) {
                                    event.preventDefault();
                                }
                            };

                            return <div className='col-sm-12' key={`update_job_pipeline_input_item_${column.key}`}>
                                <div className='form-group'>
                                    <label className={'w-100'}>{column.label}</label>
                                    <div className={'row'}>
                                        {column.inputRange && inputMode !== DVTJCUVPipelineInputMode.Search &&
                                            <>
                                                <div className='col-sm-4 pr-0'>
                                                    <input className='form-control' type={'number'} placeholder={'Nhập số tuần/tháng'}
                                                        value={column?.timeRangeNumber || ''}
                                                        min={'0'}
                                                        disabled={!column.editable}
                                                        onKeyDown={handleKeyDownNumber}
                                                        onChange={event => onChangeRangeNumber(event, column)}
                                                    />
                                                </div>
                                                <div className='col-sm-3 pr-0'>
                                                    <Select options={TimeRangeOptions}
                                                        value={column.timeRangeSelect || TimeRangeOptions[0]}
                                                        isDisabled={!column.editable}
                                                        onChange={value => {
                                                            onChangeRangeOption(value, column);
                                                        }}
                                                    />
                                                </div>
                                            </>
                                        }
                                        <div className={column.inputRange && inputMode !== DVTJCUVPipelineInputMode.Search ? 'col-sm-5' : 'col-sm-12'}>
                                            <input type={column.inputType} className='form-control'
                                                disabled={(inputMode === DVTJCUVPipelineInputMode.Edit && !column.editable) || disableFields.includes(column.key)}
                                                value={getItemValues(column, dvtjcuvPipeline[column.key])}
                                                name={column.key} onChange={event => onChangeInput(event.target.value, column)} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        })}
                    </div>
                </div>
            })}

        </div>
    )
}

export default DVTJCUVPipelineInputFormNew;
